import { Injectable } from '@angular/core';
import { GraphqlService } from '@app/core/services/graphql.service';
import { advancedSearchWithUserConfigurationQuery } from '@app/pcs/data/advanced-search.queries';
import {
  addLabelMutation,
  createLabelMutation,
  removeLabelFromDossiersMutation,
  removeLabelMutation,
  saveLabelMutation,  shareLabelMutation} from '@app/pcs/data/user-label.mutations';
import {
  dossierLabelsQuery,
  eligibleUsersForSharingQuery,
  isLabelUsedInDossiersQuery,
  sharedUsersQuery,
  userLabelsQuery
} from '@app/pcs/data/user-label.queries';
import { UserLabel } from '@app/pcs/models';
import { UserGridType } from '@app/pcs/models/user-grid-type';
import * as R from 'ramda';
import { map } from 'rxjs/operators';

@Injectable()
export class UserLabelDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  fetchLabels() {
    return this.graphqlService.query(userLabelsQuery);
  }

  fetchDossierLabels(dossierId) {
    return this.graphqlService.query(dossierLabelsQuery, {dossierId});
  }

  addDossierLabel(labelId, dossierIds) {
    return this.graphqlService.mutation(addLabelMutation, {
      labelId,
      dossierIds
    });
  }

  removeDossierLabel(labelId, dossierIds) {
    return this.graphqlService.mutation(removeLabelFromDossiersMutation, {
      labelId,
      dossierIds
    });
  }

  createDossierLabel(labelName, dossierIds) {
    return this.graphqlService.mutation(createLabelMutation, {
      labelName,
      dossierIds
    });
  }

  search(labelIds: number[]) {
    const searchCriteria = {
      labels: R.map(R.objOf('id'), labelIds)
    };
    return this.graphqlService.query(advancedSearchWithUserConfigurationQuery, {
      searchCriteria,
      userGridType: {id: UserGridType.Labels}
    }).pipe(map(response => ({
      searchResults: response[0],
      userGridConfiguration: response[1]
    })));
  }

  removeLabel(labelId: number) {
    return this.graphqlService.mutation(removeLabelMutation, {labelId});
  }

  isLabelUsedInDossiers(labelId: number) {
    return this.graphqlService.query(isLabelUsedInDossiersQuery, {labelId});
  }

  fetchEligibleUsersForSharing(labelId: number) {
    return this.graphqlService.query(eligibleUsersForSharingQuery, {labelId});
  }

  fetchSharedUsers(labelId: number) {
    return this.graphqlService.query(sharedUsersQuery, {labelId});
  }

  shareLabel(labelId: number, sharedUsers: number[]) {
    return this.graphqlService.mutation(shareLabelMutation, {labelId, sharedUsers});
  }

  saveLabel(label: UserLabel) {
    return this.graphqlService.mutation(saveLabelMutation, {label});
  }
}
